import request from '../../utils/request';

export const getCmsLanguagesService = (value = '') => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests/languages', {
        method: 'GET',
        params: { value },
      }),
    );
    return response;
  };
};
